import { configureStore } from "@reduxjs/toolkit";
import imgDataSlice, { ImagesDataArray } from "./features/imagesDataSlice";
import responseSlice, { Response } from "./features/responseSlice";
import otherSettingsSlice, { OtherSettings } from "./features/otherSettingsSlice";
import hoverIndexSlice, { HoverIndex } from "./features/hoverIndexSlice";
import exLogSlice, { ExLogArray } from "./features/exLogSlice";
import regionSlice, { Region } from "./features/regionSlice";
import globalSettingsSlice, { TypeGlobalSettings } from "./features/globalSettingsSlice";
import generalStatesSlice, { GeneralStates } from "./features/generalStatesSlice";
import dialogStatesSlice, { DialogState } from "./features/dialogStatesSlice";
import nodeStylesSlice, { NodeStyles } from "./features/nodeStylesSlice";

const store = configureStore({
  reducer: {
    imagesData: imgDataSlice,
    decodeResponse: responseSlice,
    otherSettings: otherSettingsSlice,
    hoverIndex: hoverIndexSlice,
    exLog: exLogSlice,
    region: regionSlice,
    globalSettings: globalSettingsSlice,
    generalStates: generalStatesSlice,
    dialogStates: dialogStatesSlice,
    nodeStyles: nodeStylesSlice
  },
});

export interface RootStore {
  imagesData: ImagesDataArray;
  decodeResponse: Response;
  otherSettings: OtherSettings;
  hoverIndex: HoverIndex;
  exLog: ExLogArray;
  region: Region;
  globalSettings: TypeGlobalSettings;
  generalStates: GeneralStates;
  dialogStates: DialogState;
  nodeStyles: NodeStyles;
}

export default store;